import { render } from "./LinkedCard.vue?vue&type=template&id=793fdd99&scoped=true"
import script from "./LinkedCard.vue?vue&type=script&lang=js"
export * from "./LinkedCard.vue?vue&type=script&lang=js"

import "./LinkedCard.vue?vue&type=style&index=0&id=793fdd99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-793fdd99"

export default script